export enum GenericDialogType {
  INFO = 'info',
  WARN = 'warning',
  ERR = 'error',
  SUCCESS = 'success'
}
export interface GenericDialogButton {
  text: string;
  action: 'confirm' | 'cancel';
  color?: 'primary' | 'warn' | 'accent';
  disabled?: boolean;
}

export interface GenericDialogData {
  title: string;
  message: string | string[];
  type?: GenericDialogType;
  buttons?: GenericDialogButton[];
  requireConfirmCheckbox?: boolean;
  confirmCheckboxLabel?: string;
  showNotesInput?: boolean;
  initialNotes?: string;
}

export interface GenericDialogPayload {
  notes?: string
}

export enum GenericDialogResult {
  Confirm,
  Cancel
}
